import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { State } from 'src/app/models/state.model';
import { AuthService, StateService } from 'src/app/services';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

  private state: State;

  public accepted = false;

  constructor(
    private authService: AuthService, 
    private msgService: ErrorMessageService,
    private router: Router,
    stateService: StateService
  ) {
       this.state = stateService.state;
  }

  public next() {
    this.authService.acceptPrivacyPolicy().subscribe({
      next: () => {
        this.state.me.value = {...this.state.me.value, privacyPolicyAccepted: true };

        if (this.state.isAdmin || this.state.isAssistant || this.state.isSuperAdmin)
          this.router.navigate(['/settings']);
        else
          this.router.navigate(['/']);

      }, error: (err: IResultModel<ResultModel>) => {
            this.msgService.handleError<ResultModel>(err);
      } });
  }
}
